import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  ref: "modalContent",
  id: "ContractDetailsModal"
}
const _hoisted_2 = { class: "ContractDetailsContentBlock" }
const _hoisted_3 = { class: "ContractDetailsRow" }
const _hoisted_4 = { class: "ContractDetailsCell" }
const _hoisted_5 = { class: "ContractDetailsCell" }
const _hoisted_6 = { class: "ContractDetailsCell" }
const _hoisted_7 = { class: "ContractDetailsRow" }
const _hoisted_8 = { class: "ContractDetailsCell" }
const _hoisted_9 = { class: "ContractDetailsCell" }
const _hoisted_10 = { class: "ContractDetailsCell" }
const _hoisted_11 = { class: "ContractDetailsRow" }
const _hoisted_12 = { class: "ContractDetailsSegmentBlock" }
const _hoisted_13 = {
  key: 0,
  class: "ContractDetailsSegmentTitle IncludedSegment"
}
const _hoisted_14 = {
  key: 1,
  class: "ContractDetailsSegmentTitle ExcludedSegment"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "ContractDetailsSubSectionTitle" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "ContractDetailsHeaderBlock" }, [
      _createElementVNode("h3", null, "Contract summary")
    ], -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "Account name (CRM)", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.contractName), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "Annual fee", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.annualFee), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[2] || (_cache[2] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "Work order ID", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.contractId), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "First promo start date", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.firstPromotionStartDate), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[4] || (_cache[4] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "Contract end", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.contractEndDate), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "ContractDetailsTitle" }, "Tail-period end", -1 /* CACHED */)),
          _createElementVNode("div", null, _toDisplayString(_ctx.tailPeriodEndDate), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.segments, (segment) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.isSegmentTypeIncluded(segment))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "SegmentTypeIcon lnr-checkmark-circle" }, null, -1 /* CACHED */)),
                  _createElementVNode("span", null, "Included segment " + _toDisplayString(_ctx.calculateNumberOfSegment(segment)), 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "SegmentTypeIcon lnr-prohibited" }, null, -1 /* CACHED */)),
                  _createElementVNode("span", null, "Excluded segment " + _toDisplayString(_ctx.calculateNumberOfSegment(segment)), 1 /* TEXT */)
                ])),
            _createElementVNode("div", {
              class: _normalizeClass([
						'ContractDetailsSection',
						_ctx.isSegmentProgrammeSectionIrrelevant(segment) ? 'IrrelevantSection' : ''
					])
            }, [
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ContractDetailsSubSectionTitle" }, [
                _createElementVNode("i", { class: "SegmentSubSectionIcon lnr-magnifier" }),
                _createElementVNode("span", null, "Programmes")
              ], -1 /* CACHED */)),
              _createElementVNode("div", {
                class: "ContractDetailsSubSectionDetails",
                innerHTML: _ctx.retrieveSegmentProgrammeDetails(segment)
              }, null, 8 /* PROPS */, _hoisted_15)
            ], 2 /* CLASS */),
            _createElementVNode("div", {
              class: _normalizeClass([
						'ContractDetailsSection',
						_ctx.isSegmentStudentSectionIrrelevant(segment) ? 'IrrelevantSection' : ''
					])
            }, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "ContractDetailsSubSectionTitle" }, [
                _createElementVNode("i", { class: "SegmentSubSectionIcon lnr-map-marker" }),
                _createElementVNode("span", null, "Students")
              ], -1 /* CACHED */)),
              _createElementVNode("div", {
                class: "ContractDetailsSubSectionDetails",
                innerHTML: _ctx.retrieveSegmentStudentDetails(segment)
              }, null, 8 /* PROPS */, _hoisted_16)
            ], 2 /* CLASS */),
            (_ctx.isSegmentTypeIncluded(segment))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", {
                    class: _normalizeClass([
							'ContractDetailsSection',
							_ctx.isSegmentAttributionSectionIrrelevant(segment) ? 'IrrelevantSection' : ''
						])
                  }, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "ContractDetailsSubSectionTitle" }, [
                      _createElementVNode("i", { class: "SegmentSubSectionIcon lnr-link" }),
                      _createElementVNode("span", null, "Attribution")
                    ], -1 /* CACHED */)),
                    _createElementVNode("div", {
                      class: "ContractDetailsSubSectionDetails",
                      innerHTML: _ctx.retrieveSegmentAttributionDetails(segment)
                    }, null, 8 /* PROPS */, _hoisted_17)
                  ], 2 /* CLASS */),
                  _createElementVNode("div", {
                    class: _normalizeClass([
							'ContractDetailsSection',
							_ctx.isSegmentPricingSectionIrrelevant(segment) ? 'IrrelevantSection' : ''
						])
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _cache[11] || (_cache[11] = _createElementVNode("i", { class: "SegmentSubSectionIcon lnr-bag-coins" }, null, -1 /* CACHED */)),
                      _createElementVNode("span", {
                        innerHTML: `Price per ${_ctx.retrieveSegmentPriceTypeName(segment)}`
                      }, null, 8 /* PROPS */, _hoisted_19)
                    ]),
                    _createElementVNode("div", {
                      class: "ContractDetailsSubSectionDetails",
                      innerHTML: _ctx.retrieveSegmentPricingDetails(segment)
                    }, null, 8 /* PROPS */, _hoisted_20)
                  ], 2 /* CLASS */)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", {
              class: _normalizeClass([
						'ContractDetailsSection',
						_ctx.isSegmentCommentsSectionIrrelevant(segment) ? 'IrrelevantSection' : ''
					])
            }, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "ContractDetailsSubSectionTitle" }, [
                _createElementVNode("i", { class: "SegmentSubSectionIcon lnr-bubbles" }),
                _createElementVNode("span", null, "Comments")
              ], -1 /* CACHED */)),
              _createElementVNode("div", {
                class: "ContractDetailsSubSectionDetails",
                innerHTML: _ctx.retrieveSegmentCommentDetails(segment)
              }, null, 8 /* PROPS */, _hoisted_21)
            ], 2 /* CLASS */)
          ]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ])
    ])
  ], 512 /* NEED_PATCH */))
}